(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kutzall-creatures-2026"] && !Shopify.designMode) return;
  try {
    
function initKC26Voting(root){
  if(root.dataset.votingBound)return;
  root.dataset.votingBound='true';
  const dialog=root.querySelector('.kv-dialog');
  if(!dialog||typeof dialog.showModal!=='function')return;
  const image=dialog.querySelector('img');
  const caption=dialog.querySelector('p');
  let opener;
  root.addEventListener('click',function(event){
    const link=event.target.closest('[data-mask-image]');
    if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
    event.preventDefault();opener=link;image.src=link.href;image.alt=link.dataset.caption;caption.textContent=link.dataset.caption;dialog.showModal();
  });
  dialog.querySelector('button').addEventListener('click',function(){dialog.close();});
  dialog.addEventListener('click',function(event){if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('close',function(){if(opener)opener.focus();});
}
document.querySelectorAll('.kv-root').forEach(initKC26Voting);
document.addEventListener('shopify:section:load',function(event){const root=event.target.querySelector('.kv-root');if(root)initKC26Voting(root);});

  } catch(e) { console.error(e); }
})();
})();
